import { useSyncExternalStore } from "react";

/** Lets any surface open the Ask AI guide without owning its state. */
const OPEN_GUIDE_EVENT = "amoreg:open-guide";

export function openGuide(): void {
  window.dispatchEvent(new CustomEvent(OPEN_GUIDE_EVENT));
}

export function onOpenGuide(listener: () => void): () => void {
  window.addEventListener(OPEN_GUIDE_EVENT, listener);
  return () => window.removeEventListener(OPEN_GUIDE_EVENT, listener);
}

let shortcutClaim: (() => void) | null = null;
const claimListeners = new Set<() => void>();

const setShortcutClaim = (handler: (() => void) | null) => {
  shortcutClaim = handler;
  for (const listener of claimListeners) listener();
};

/**
 * A page whose own panel answers the guide's shortcut (the Workflows page's
 * Ask eve) takes it while mounted; the returned function gives it back.
 */
export function claimGuideShortcut(handler: () => void): () => void {
  setShortcutClaim(handler);
  return () => {
    if (shortcutClaim === handler) setShortcutClaim(null);
  };
}

/** Runs the claiming page's handler; false when no page holds the shortcut. */
export function runGuideShortcutClaim(): boolean {
  if (shortcutClaim === null) return false;
  shortcutClaim();
  return true;
}

const subscribeShortcutClaim = (listener: () => void) => {
  claimListeners.add(listener);
  return () => {
    claimListeners.delete(listener);
  };
};
const isShortcutClaimed = () => shortcutClaim !== null;

/** Whether a page holds the guide's shortcut now, so the guide's chip does not name it too. */
export function useGuideShortcutClaimed(): boolean {
  return useSyncExternalStore(subscribeShortcutClaim, isShortcutClaimed, () => false);
}
